/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ThumbDownOutlineIcon = function ThumbDownOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14C3.89543 14 3 13.1046 3 12V5C3 3.89543 3.89543 3 5 3L16.25 3.00006C17.5833 3.00006 18.7567 3.88006 19.13 5.16006L20.88 11.1601C21.44 13.0801 20 15.0001 18 15.0001H15L15.4072 16.629C15.438 16.7522 15.4628 16.876 15.4816 17.0001C15.685 18.3409 15.1943 19.7051 14.1607 20.6095L12.8354 21.7691C12.3888 22.1599 11.7021 22.078 11.3599 21.5932L6.36606 14.5187C6.25304 14.3585 6.16486 14.1837 6.10339 14H5ZM8 13.3653L12.3537 19.533L12.8437 19.1043C13.4083 18.6103 13.6489 17.8419 13.467 17.1141L12.4384 13.0001H18C18.6667 13.0001 19.1467 12.3601 18.96 11.7201L17.21 5.72006C17.0856 5.29339 16.6944 5.00006 16.25 5.00006H8L8 13.3653Z"
  }));
};
export default ThumbDownOutlineIcon;